import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IonModal, ModalController, NavController } from "@ionic/angular";
import { GlobalsService } from "src/app/api/globals.service";
import { AppComponent } from "src/app/app.component";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import { ProductosService } from "src/app/services/productos.service";
import { ToastService } from "src/app/services/toast.service";
import { Platform } from "@ionic/angular";
import { environment } from "src/environments/environment";

import { Observable, Subject } from "rxjs";
import { ActividadesService } from "src/app/services/actividades.service";
import { statusCurse } from "src/app/Enum/statusCurse.enum";

@Component({
  selector: "app-agregar-libro",
  templateUrl: "./agregar-libro.component.html",
  styleUrls: ["./agregar-libro.component.scss"],
})
export class AgregarLibroComponent implements OnInit {
  @ViewChild("modalFilterData", { static: false }) modalFilterData: IonModal;
  @Input() public curso: any;
  @Input() public DATA_LIBRO: any;
  @Input() public DATA_CURSO: any;
  ismobile;
  argumentos = null;
  displayUserData: any;
  opcion: number = 1;
  _CURSO: any;
  CURSO: any;
  public is_curso: boolean = false;
  public nombre_curso: string;
  arrayisInList: any = [];

  ordenar: any;
  products: any;
  minprice: number;
  maxprice: number;

  minedad: number;
  maxedad: number;
  edades: any;
  rangeEdadmin: any;
  rangeEdadmax: any;

  //autorList:any;
  autorList: any = [];
  coleccionList: any = [];

  qtylibro: any = [];
  autoresList = false;
  coleccionesList = false;
  edadesList = false;
  defaultqty: number;
  selectqty: number[];
  cantidades: { value: string; selected: boolean }[];
  setFiscoDigital: any = [];
  loadproductsW: boolean;
  rangemax: any;
  rangemin: any;
  ordenOpt = "";
  ACTIVIDADES: any = [];
  ACTIVIDAD_CURSO: any = [];
  CONTINUE: number = 0;
  imgUrl = "";
  suscripcion = false;
  statusCurse = statusCurse;
  isIos = false;

  filtrosSeleccionados = {
    search: "",
    niveles: [],
    materias: [],
    profesores: [],
    type: true,
  };
  currentPage = 1;
  totalItems = 0;
  pageSize = 24;
  dataFilter: any = {};
  dataLoaded = false;
  rutaRef = "";

  constructor(
    public globalsService: GlobalsService,
    public navCtrl: NavController,
    private cursosService: CursosService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private service: ProductosService,
    public toastService: ToastService,
    public router: Router,
    public plt: Platform,
    public actividadesService: ActividadesService
  ) {
    this.isIos = globalsService.plataforma == "ios" ? true : false;
    this.ismobile = globalsService.isMobile;
    this.rutaRef = environment.urlFront + "ecommerce";

    this.imgUrl = environment.host + "/uploads/assets/imagenes/productos/";
    this.ismobile = globalsService.isMobile;
    this.argumentos = this.activeRoute.snapshot.paramMap.get("id_curso");
    this.CURSO = {
      id_curso: this.argumentos,
      libros: [],
    };
  }

  ngOnInit() {
    this.loadUserData();
  }
  loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        if (res) {
          if (!this.displayUserData) {
            this.displayUserData = res;

            resolve(true);
          }
        }
      });
    });
    promise.then((success) => {
      if (success) {
        this.loadLibrarySelect();
        this.loadProducts();
        this.getlicense();
      }
    });
  }

  setContenido(id) {
    this.opcion = id;
  }

  loadLibrarySelect() {
    this.cursosService
      .getCursoLibro(
        this.displayUserData.id,
        this.curso.id,
        this.displayUserData.auth_key
      )
      .subscribe((res: any) => {
        let libros: any = res;
        if (libros.length > 0) {
          libros.forEach((element) => {
            this.arrayisInList.forEach((el) => {
              if (element.id == el.id) {
                el.inList = true;
              }
            });
            this.CURSO.libros.push({
              id: element.id,
              imagen: element.imagen,
            });
          });
        }
      });
  }

  loadProducts() {
    this.dataLoaded = false;
    this.service
      .getProductosFilter(this.dataFilter, this.currentPage)
      .subscribe((response) => {
        this.dataLoaded = true;
        this.totalItems = response.totalCount;
        this.products = response.result;
        this.maxprice = response.precio_mayor;
        this.minprice = response.precio_menor;
      });
  }
  addToList(id, index, imagen) {
    let inlist = false;
    this.arrayisInList.forEach((element) => {
      if (element.id == id) {
        if (element.inList) {
          inlist = true;
        }
        element.inList = true;
      }
    });
    if (inlist) {
      return;
    }
    this.cursosService
      .addCursoLibro(
        this.displayUserData.id,
        this.curso.id,
        id,
        this.displayUserData.auth_key
      )
      .subscribe((res: any) => {
        console.log(res);
        if (!res.error) {
          this.CURSO.libros.push({ id: id, imagen: imagen });
          this.arrayisInList.forEach((element) => {
            if (element.id == id) {
              element.inList = true;
            }
          });
        }
      });
  }
  removeItemList(id) {
    let inlist = false;
    this.arrayisInList.forEach((element) => {
      if (element.id == id) {
        if (element.inList) {
          inlist = false;
        }
        element.inList = false;
      }
    });
    this.cursosService
      .rmCursoLibro(
        this.displayUserData.id,
        this.curso.id,
        id,
        this.displayUserData.auth_key
      )
      .subscribe((res: any) => {
        console.log(res);
        if (!res.error) {
          let books = this.CURSO.libros;
          books.forEach((element, i, array) => {
            if (element.id == id) {
              books.splice(i, 1);
            }
          });
        }
      });
  }
  detalles(id) {
    this.navCtrl.navigateRoot("libreria/libro/" + id);
  }

  onChangePage(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.loadProducts();
  }

  getlicense() {
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      let auth_key = this.displayUserData?.auth_key;
      if (auth_key) {
        this.service
          .getLicense(auth_key, this.displayUserData.id)
          .subscribe((response: any) => {
            if (response.suscripcion) {
              this.suscripcion = true;
            }
          });
      }
    });
  }

  navigateSuscripcion() {
    this.navCtrl.navigateRoot("/ecommerce");
  }

  filtro(data: any) {
    this.filtrosSeleccionados = data;
    this.dataFilter = {
      name: data.search,
      autor: data.autores,
      coleccion: data.coleccion,
      e1: data.edades?.lower,
      e2: data.edades?.upper,
      p1: data.precios?.lower,
      p2: data.precios?.upper,
    };
    if (this.ismobile && data.type) {
      this.modalFilterData.dismiss();
    }
    this.loadProducts();
  }
}
